<template>
    <div class="home" style="height: calc(100vh - 132px);" ref="appContainer" v-loading="loading">
        <div class="d-b-c">
            <div class="operation-wrap">
                <el-row :gutter="20">
                    <el-col :span="12" :offset="6" class="d-c-c">
                        <div class="sign">
                            <div class="title">
                                <span class="title-icon icon iconfont menu-item-icon icon-zhuanyemingcheng"></span>
                                <span>{{ majorData.major_name }}</span>
                            </div>
                            <div class="tip">
                                <el-col :span="14" class="tip-title" :offset="1">
                                    <div>考生报名时间：报名时间请关注物业协会通知</div>
                                    <div>考试安排时间：具体考试时间以准考证为准</div>
                                </el-col>
                                <el-col :span="9" class="tip-btn">
                                    <el-button @click="goFile()">附件材料</el-button>
                                    <el-button type="primary" @click="sign()">进入报名</el-button>
                                </el-col>
                            </div>
                            <div class="describe">
                                <div>
                                    <div class="describe-title">报考说明：</div>
                                    <div v-html="majorData.describe"></div>
                                </div>
                                <div class="major-file">
                                    <div class="describe-title">专业附件：</div>
                                    <div v-if="majorData.attached">
                                        <div style="margin-bottom: 10px;" v-for="(item,index) in majorData.attached">
                                            <div>{{ index+1 }}. {{ item.file[0].attached_name}}</div>
                                        </div>
                                    </div>
                                    <div v-else>暂无附件材料说明</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="home-index">

        </div>
    </div>
</template>

<script>
    import IndexApi from '@/api/index.js';
    import { setCookie } from '@/utils/base.js';

    export default {
        data() {
            return {
                loading: true,
                major_id: '',
                majorData: {},
            };
        },
        mounted(){
        },
        created() {
            this.major_id = this.$route.query.major_id
            // 获取数据
            this.getData();
        },
        methods: {
            // 获取数据
            getData() {
                let that = this;

                IndexApi.getMajorDetail({
                    major_id: that.major_id,
                }).then(res => {
                    that.majorData = res.data.data
                    that.loading = false;
                }).catch(error => {

                });
            },

            // 附件材料
            goFile(){
                this.$router.push({path: '/file'})
            },

            // 进入报名
            sign(){
                // 设置专业id
                setCookie('major_id', this.major_id);
                this.$router.push({path: '/instructions/index'})
            }
        }
    };
</script>

<style lang="scss" scoped>
    .operation-wrap {
        width: 100%;
        border-radius: 8px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        overflow: unset;
        background: #fff;
        background-size: 100% 100%;
        color: #FFFFFF;
        margin-bottom: 20px;
        .sign{
            width: 100%;
            min-height: 500px;
            background-color: #eee;
            border-radius: 15px;
            .title{
                height: 60px;
                width: 100%;
                background-color: #409eff;
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: bold;
                color: #fff;
                padding-left: 20px;
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;
                .title-icon{
                    font-size: 32px;
                    margin-right: 10px;
                }
            }
            .tip{
                color: #000;
                font-size: 14px;
                background-color: #fff;
                height: 100px;
                border: 1px solid #eee;
                .tip-title{
                    padding: 30px;
                }
                .tip-btn{
                    padding: 30px;
                    text-align: right;
                }
            }
            .describe{
                color: #000;
                font-size: 14px;
                padding: 30px;
                .describe-title{
                    font-size: 16px;
                    font-weight: bold;
                }
                .major-file{
                    margin-top: 15px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/home/major.vue